import { zod } from "@endya-conformite/ui-kit/src/lya/exports";
import { UseFormReturn } from "@endya-conformite/ui-kit/src/lya/react-hook-form";
import {
  Form,
  InputButtonGroup,
  useFormConfig,
  FormField,
  FormRow,
} from "@endya-conformite/ui-kit";
import { ParcoursAdhesionNextAction } from "@src/adhesion/AdhesionActions/ParcoursAdhesionNextAction";
import { ParcoursAdhesionSaveAndQuitAction } from "@src/adhesion/AdhesionActions/ParcoursAdhesionSaveAndQuitAction";
import {
  AdhesionStepEnum,
  ID_FORM_ADHESION,
  ParcoursAdhesionStepComponentProps,
} from "@src/adhesion/ParcoursAdhesion.definition";
import { ParcoursFullPageTemplate } from "@src/parcours/Template/ParcoursFullPageTemplate";
import { useRef } from "react";

const currentYear = new Date().getFullYear();

const schema = zod.object({
  millesime: zod
    .number({
      errorMap: () => ({ message: "Veuillez sélectionner un millésime." }),
    })
    .min(currentYear)
    .max(currentYear + 1),
});

type ChoixMillesimeFormValues = zod.infer<typeof schema>;

export type AdhesionChoixMillesimeFormHandle = {
  getFormConfig: () => UseFormReturn<ChoixMillesimeFormValues>;
};

export function AdhesionChoixMillesime({
  addData,
  handleQuit,
  changeStep,
}: ParcoursAdhesionStepComponentProps) {
  const formRef = useRef<AdhesionChoixMillesimeFormHandle>(null);
  const formConfig = useFormConfig<typeof schema, ChoixMillesimeFormValues>({
    schema,
  });

  const handleSubmit = (data: ChoixMillesimeFormValues) => {
    addData({ millesime: data.millesime });
    changeStep(AdhesionStepEnum.PAIEMENT_ADHESION);
  };

  return (
    <ParcoursFullPageTemplate
      title="Je souhaite adhérer pour..."
      actions={
        <>
          <ParcoursAdhesionSaveAndQuitAction
            addData={addData}
            formConfig={() => formRef?.current?.getFormConfig()}
            handleQuit={handleQuit}
            transformValues={(formValues) => ({
              millesime: formValues.millesime,
            })}
          />
          <ParcoursAdhesionNextAction type="submit">
            Suivant
          </ParcoursAdhesionNextAction>
        </>
      }
    >
      <Form
        formConfig={formConfig}
        onSubmit={handleSubmit}
        id={ID_FORM_ADHESION}
      >
        <FormRow>
          <FormField>
            <InputButtonGroup<ChoixMillesimeFormValues, false, number>
              size="large"
              name="millesime"
              variant="outline-pop"
              options={[
                {
                  label: `le millésime ${currentYear} et ${currentYear + 1}`,
                  value: currentYear,
                },
                {
                  label: `le millésime ${
                    currentYear + 1
                  } (l'adhésion débutera le 1er janvier ${currentYear + 1})`,
                  value: currentYear + 1,
                },
              ]}
            />
          </FormField>
        </FormRow>
      </Form>
    </ParcoursFullPageTemplate>
  );
}
